export default "__VITE_ASSET__bcc917da__"